import styled from '@emotion/styled';
import { useCloudinaryPictureOverlay } from '../../../OC/oc-picture-overlay';

const NavSlide = styled.a`
  background-image: url('${props => props.background}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 1em;
  padding-bottom: 70%;
  position: relative;
  width: 100%;

  &:after {
    background-color: ${props =>
      props.slideIndex === props.currentIndex ? '#666666' : 'transparent'};
    bottom: -1em;
    content: '';
    display: inline-block;
    height: 0.214em;
    position: absolute;
    width: 100%;
  }
`;

const Nav = ({
  id,
  currentSlide,
  onClick,
  slideIndex,
  baseLayer,
  overlays,
}) => {
  const { imageUrl } = useCloudinaryPictureOverlay({
    baseLayer: baseLayer.mobile,
    overlays: overlays.mobile,
  });

  return (
    <NavSlide
      background={imageUrl}
      currentIndex={currentSlide}
      onClick={onClick}
      slideIndex={id}
      data-slide-index={slideIndex}
      data-track="learn-more"
      data-track-element-location="shingle-slider"
      data-track-destination={id}
    />
  );
};

export default Nav;
